import { render } from "./Rouwdrukwerk.vue?vue&type=template&id=4a741bf9"
import script from "./Rouwdrukwerk.vue?vue&type=script&lang=js"
export * from "./Rouwdrukwerk.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__